<header class="info-page-card__header">
  <app-back-button [navigateTo]="navigateTo" variant="transparent"></app-back-button>
  <div class="info-page-card__text-wrapper">
    <h1 class="info-page-card__title">{{ label }}</h1>
    <h2 class="info-page-card__subtitle" *ngIf="translatedSublabel">{{ translatedSublabel }}</h2>
  </div>
</header>
